<template>
  <div class="main-layout">
    <five-fold-header />
    <navbar />

    <b-container class="mt-4">
      <child />
    </b-container>
    <b-container class="container mt-4 text-center">
      <p> {{ $t('footer_created_by') }}</p>
      <p> {{ $t('footer_send_comments_and_feedback_to') }}: eric@visionlaunchers.com </p>
    </b-container>
  </div>
</template>

<script>
import Child from '~/components/Child.vue'
import Navbar from '~/components/Navbar'
import FiveFoldHeader from '~/components/five-fold-header.vue'

export default {
  name: 'MainLayout',

  components: {
    Child,
    FiveFoldHeader,
    Navbar
  }
}
</script>
